import React from 'react';
import PropTypes from 'prop-types';

import { ReclamationActionDetailType } from 'constants.js';

import withStyles from '@mui/styles/withStyles';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';


import CreateIcon from '@mui/icons-material/Create';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import MemoIcon from '@mui/icons-material/Announcement';
import ClotureIcon from '@mui/icons-material/Archive';
import AnnulerClotureIcon from '@mui/icons-material/Unarchive';
import MinimizeIcon from '@mui/icons-material/Minimize';
import LinkIcon from '@mui/icons-material/Link';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LiveHelp from '@mui/icons-material/LiveHelp';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import CircleIcon from '@mui/icons-material/Circle';
import SendIcon from '@mui/icons-material/Send';

import Datetime from 'components/Shared/Datetime';

import Utilisateur from 'components/Shared/Utilisateur';

import AddReponse from './AddReponse';
import AcknowledgeRegularisationStock from './AcknowledgeRegularisationStock';
import AddReponseToSouffranceTransporteurMemo from './AddReponseToSouffranceTransporteurMemo';
import ConfirmationReceptionFournisseur from './ConfirmationReceptionFournisseur';
import DownloadDemandePieceDetachee from './DownloadDemandePieceDetachee';
import AddReponseToSavGesteCommercial from './AddReponseToSavGesteCommercial';
import RelancerGenerationAvoir from './RelancerGenerationAvoir';
import RelancerReclamationSurBonDeVente from './RelancerReclamationSurBonDeVente';
import ReclamationSurBonDeVenteDetail from 'components/Shared/ReclamationSurBonDeVenteDetail';
import AcknowledgeDemandeVirement from './AcknowledgeDemandeVirement';

// eslint-disable-next-line
import ReclamationPageHeader from 'components/Screens/ReclamationPage/ReclamationPageHeader/ReclamationPageHeader.js';


import { TypeActionCodes } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { GroupeTraitementCodes } from 'constants.js';
import InfoSuiviColis from 'components/Shared/InfoSuiviColis';
import GeswebLink from 'components/Shared/GeswebLink';
import Fichier from 'components/Shared/Fichier';
import { orange, green, red, blue } from '@mui/material/colors';

const styles = theme => ({
    cardHeaderWithContent: {
        paddingBottom: '0px'
    },
    cardContent: {
        padding: theme.spacing(0, 3, 2, 3)
    },
    cardActions: {
        justifyContent: 'center'
    },
    container: {
        display: 'flex'
    },
    containerLeft: {
        whiteSpace: 'nowrap'
    },
    containerRight: {
        paddingLeft: theme.spacing(2),
        whiteSpace: 'pre-line',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap'
    },
    divider: {
        margin: theme.spacing(1.5, 0, 1.5, 0)
    },
    detailValue: {
        paddingLeft: theme.spacing(4),
        whiteSpace: 'pre-line'
    },
    detailValueSupprimee: {
        textDecoration: 'line-through'
    },
    orange: {
        color: orange[500]
    },
    green: {
        color: green[500]
    },
    red: {
        color: red[500]
    },
    blue: {
        color: blue[500]
    },
    filescontainer: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'row wrap',
        paddingLeft: theme.spacing(4)
    },
    filescontainerEnfant: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'row wrap'
    },
    icon: {
        margin: 0,
        padding: 0
    },
    link: theme.style.link
});

const actionIcon = {
    DEFAULT: MinimizeIcon,
    AFFECTATION_GROUPE: GroupIcon,
    AFFECTATION_UTILISATEUR: PersonIcon,
    CREATION: CreateIcon,
    QUESTION: QuestionAnswerIcon,
    'QUESTION_REPONSE_ATTENDUE': LiveHelp,
    OBSERVATEUR_AJOUT: RemoveRedEyeIcon,
    OBSERVATEUR_SUPPRESSION: VisibilityOffIcon,
    MEMO: MemoIcon,
    REPONSE: MemoIcon,
    CLOTURE: ClotureIcon,
    ANNULER_CLOTURE: AnnulerClotureIcon,
    RECLAMATION_LIEE: LinkIcon,
    SOUFFRANCE_TRANSPORTEUR_MEMO: FileCopyIcon,    
    SUCCES_GENERATION_AVOIR: ThumbUpIcon,
};

const hideMail = [
    TypeActionCodes.TransportDemanderRelivraison,
    TypeActionCodes.TransportDemanderImperatif,
    TypeActionCodes.TransportDemanderRechercheColis,
    TypeActionCodes.TransportRenvoiAvecFacturation,
    TypeActionCodes.TransportDemanderEnqueteChauffeur,
    TypeActionCodes.TransportPlainteLivraisonSauvage,
    TypeActionCodes.TransportDemandeMiseEnDestruction,
    TypeActionCodes.TransportOrdreEnlevementMatieresDangeureusesInflammables,
    TypeActionCodes.TransportReponseSouffranceTransporteur,

    TypeActionCodes.TransportRechercheColisSiteWeb,
];

class HistoriqueCard extends React.Component {

    isDevelopment = process.env.NODE_ENV === 'development';

    getTitle() {
        let { action } = this.props;

        switch (action.typeActionCode) {
            case TypeActionCodes.AffectationGroupe:
            case TypeActionCodes.ObservateurAjout:
            case TypeActionCodes.ObservateurSuppression:
                return `${action.typeActionLibelle} : ${action.details[0] === undefined ? '???' : action.details[0].value}`;
            case TypeActionCodes.AffectationUtilisateur:
                return `${action.typeActionLibelle} : ${action.details[1] === undefined ? '???' : action.details[1].value} (${action.details[0] === undefined ? '???' : action.details[0].value})`;
            default:
                return action.typeActionLibelle;
        }
    }

    /* eslint-disable react/display-name */
    getIcon() {
        let { classes, action } = this.props;

        let Icon = actionIcon[action.typeActionCode];
        if (!Icon) Icon = actionIcon['DEFAULT'];

        if (action.typeActionCode === TypeActionCodes.Question) {
            if (action.actions.length > 0) {
                var derniere = action.actions[action.actions.length - 1];

                if (derniere.reponseAttendue === true) {
                    Icon = () => <LiveHelp className={classes.orange} titleAccess={"action_" + action.id} />;
                }
            }
            else {
                Icon = () => <LiveHelp className={classes.orange} titleAccess={"action_" + action.id} />;
            }
        }

        if (action.typeActionCode === TypeActionCodes.ErreurGenerationAvoir) {

            Icon = () => <ErrorIcon className={classes.orange} titleAccess={"action_" + action.id} />;

        }


        // Action de déclenchement RECENT : avion (envoi vers Gescom).
        //  - bleu  : au moins une sous-action de succès (RECENT généré)
        //  - rouge : aucune sous-action de succès (échec ou en attente)
        if (action.typeActionCode === TypeActionCodes.GenerationRecent) {
            const succes = action.actions
                && action.actions.some(a => a.typeActionCode === TypeActionCodes.SuccesGenerationRecent);

            Icon = () => <SendIcon className={succes ? classes.blue : classes.red} titleAccess={"action_" + action.id} />;
        }

        // Entrée synthétique RECENT : pastille d'état selon le statut d'intégration.
        //  - vert   : intégré et cohérent (aucun statut d'erreur)
        //  - orange : en attente du premier message de Gescom
        //  - rouge  : erreur (sans dossier, dossier inexistant, incohérence commande)
        if (action.typeActionCode === TypeActionCodes.ReclamationSurBonDeVente) {
            const statut = action.details
                ? action.details.find(d => d.libelle === 'Statut')
                : null;

            let couleur = classes.green;
            if (statut && statut.value) {
                couleur = statut.value.indexOf('sans message initial') !== -1 ? classes.orange : classes.red;
            }

            Icon = () => <CircleIcon className={couleur} titleAccess={"action_" + action.id} />;
        }

        if (action.typeActionCode === TypeActionCodes.QualiteEntrepotControlePoids) {
            Icon = () => <SvgIcon className={classes.icon} style={{ width: '24px', height: '24px' }} viewBox="0 0 28 28"><path d="M12,3A4,4 0 0,1 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7A4,4 0 0,1 12,3M12,5A2,2 0 0,0 10,7A2,2 0 0,0 12,9A2,2 0 0,0 14,7A2,2 0 0,0 12,5Z" /></SvgIcon>;
        }

        return Icon;
    }

    getBGColor() {
        let { action } = this.props;

        //if (action.typeActionCode === TypeActionCodes.ErreurGenerationAvoir) {
        //    return "Tomato"
        //}

        return "Ivory";
    }

    getDetailValue(detail, index, typeActionCode) {

        let { classes } = this.props;

        let libelle = detail.libelle;
        let value = <Typography variant="body2" gutterBottom className={classes.detailValue}>{detail.value}</Typography>;

        // BOOLEEN
        if (detail.type === ReclamationActionDetailType.Booleen)
            value = <Typography variant="body2" gutterBottom className={classes.detailValue}>{detail.value ? 'Oui' : 'Non'}</Typography>;

        // DATE
        if (detail.type === ReclamationActionDetailType.Date)
            value = <Typography variant="body2" gutterBottom className={classes.detailValue}><Datetime datetime={detail.value} /></Typography>;

        // DATE TIME
        if (detail.type === ReclamationActionDetailType.DateTime)
            value = <Typography variant="body2" gutterBottom className={classes.detailValue}><Datetime withTime datetime={detail.value} /></Typography>;

        // Pièce et suivi colis
        if ((typeActionCode === TypeActionCodes.TransportRenvoyerMarchandise || typeActionCode === TypeActionCodes.TransportFacturerTransporteur)
            && detail.code === ReclamationActionDetailCodes.NumeroPiece)
            value = (
                <React.Fragment>
                    <Typography variant="body2" gutterBottom className={classes.detailValue}>{detail.value}</Typography>
                    <InfoSuiviColis numeroPiece={detail.value} />
                </React.Fragment>
            );

        // RECLAMATION_LIEE
        if (detail.type === ReclamationActionDetailType.ReclamationId) {
            libelle = '';
            value = (<a target="_blank" href={`/reclamations/${detail.value.id}`} rel="noopener noreferrer" className={classes.link}>
                <ReclamationPageHeader reclamation={detail.value} onClickSetVerificationDate={null} afficheVerification={false} />
            </a>);
        }

        // Packing List
        // La packing list peut avoir été supprimée depuis (dossier réaffecté à une autre) :
        // le backend renvoie alors le numéro en texte au lieu de l'objet. On l'affiche barré.
        if (detail.type === ReclamationActionDetailType.PackingList) {
            const packingListSupprimee = detail.value === null || typeof detail.value !== 'object';

            value = (
                <React.Fragment>
                    <Typography
                        variant="body2"
                        gutterBottom
                        className={`${classes.detailValue}${packingListSupprimee ? ' ' + classes.detailValueSupprimee : ''}`}
                        title={packingListSupprimee ? 'Cette packing list a été supprimée' : undefined}
                    >
                        {packingListSupprimee ? detail.value : detail.value.id}
                    </Typography>
                </React.Fragment>
            )
        }

        // Lien Gesweb vers la commande (ex. pièce d'avoir).
        // detail.value = numéro de pièce (affiché) ; detail.libelle = clé Gesweb (dataId du lien).
        if (detail.type === ReclamationActionDetailType.LienGeswebCommande) {
            libelle = 'Numéro de pièce avoir';
            value = (
                <Typography variant="body2" gutterBottom className={classes.detailValue} component="div">
                    {detail.libelle
                        ? <GeswebLink mode="button" label={detail.value} structure="commande" cle={detail.libelle} />
                        : detail.value}
                </Typography>
            );
        }

        // Lien Gesweb vers le bon de livraison. Pour un BL, la clé « L… » sert à la fois de libellé
        // affiché et de dataId du lien. On conserve le libellé du détail (ex. « Pièce concernée »).
        if (detail.type === ReclamationActionDetailType.LienGeswebBonLivraison) {
            value = (
                <Typography variant="body2" gutterBottom className={classes.detailValue} component="div">
                    {detail.value
                        ? <GeswebLink mode="button" label={detail.value} structure="bonlivraison" cle={detail.value} />
                        : detail.value}
                </Typography>
            );
        }

        // Réclamation sur bon de vente (RECENT) : detail.value = MessageJson complet ou clé simple.
        // On conserve le libellé du détail (affiché au-dessus du contenu).
        if (detail.type === ReclamationActionDetailType.ReclamationSurBonDeVente) {
            value = <ReclamationSurBonDeVenteDetail value={detail.value} />;
        }

        let afficheDetail = !(detail.code === ReclamationActionDetailCodes.Email && hideMail.includes(typeActionCode));

        if (typeActionCode === TypeActionCodes.AffectationGroupe || typeActionCode === TypeActionCodes.AffectationUtilisateur) {
            afficheDetail = afficheDetail && (detail.code !== ReclamationActionDetailCodes.GroupeAffecte && detail.code !== ReclamationActionDetailCodes.UtilisateurAffecte);
        }

        return (
            afficheDetail && (
                <React.Fragment key={index} >

                    {this.isDevelopment && (
                        <Tooltip title={`${detail.position} - ${detail.code}`} placement={'left-start'}>
                            <div>
                                {(detail.code !== ReclamationActionDetailCodes.Reponse) && (<Typography variant="body1" gutterBottom>{libelle}</Typography>)}
                                {value}
                            </div>
                        </Tooltip>
                    )}

                    {!this.isDevelopment && (
                        <>
                            {(detail.code !== ReclamationActionDetailCodes.Reponse) && (<Typography variant="body1" gutterBottom>{libelle}</Typography>)}
                            {value}
                        </>
                    )}

                </React.Fragment>
            )
        );
    }

    render() {
        let { classes, action, utilisateurCourantAdminOuPiloteGroupe, utilisateurCourantMagasinier,

            utilisateurCourantAdmin, utilisateurCourantPiloteGroupeInterlocuteurSAV, utilisateurCourantDirecteurRegionalClient,

            onClickRemoveAction, reloadHistory } = this.props;

        let Icon = this.getIcon();

        // Liste des actions qui n'ont pas de contenu à afficher
        let emptyContentActions = [
            TypeActionCodes.Creation,
            TypeActionCodes.ObservateurAjout,
            TypeActionCodes.ObservateurSuppression
        ];

        let emptyContent = emptyContentActions.includes(action.typeActionCode);

        // Cas spécifiques des affectations 
        if (action.typeActionCode === TypeActionCodes.AffectationGroupe || action.typeActionCode === TypeActionCodes.AffectationUtilisateur) {
            emptyContent = action.details.find(x => x.code !== ReclamationActionDetailCodes.GroupeAffecte && x.code !== ReclamationActionDetailCodes.UtilisateurAffecte) === undefined;
        }

        let filesIds = action.filesIds;
        if (action.actions && action.actions.length) {
            action.actions.forEach(function (a) {
                if (a.filesIds && a.filesIds.length > 0) {
                    filesIds = filesIds.concat(a.filesIds);
                }
            });
        }


        let autoriseFichier = true;
        // Cas spécifiques ou le téléchargement de fichier n'est pas permis à tous
        if (action.typeActionCode === TypeActionCodes.TransportReponseSouffranceTransporteur ||
            (action.typeActionCode === TypeActionCodes.TransportRechercheColisSiteWeb && action.details[0].value === 'En souffrance')) {

            let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

            autoriseFichier = utilisateurCourant.administrateur || (utilisateurCourant.groupes && utilisateurCourant.groupes.find(x => x.code === GroupeTraitementCodes.ServiceTransport) !== undefined);
        }

        let removable =
            (action.typeActionCode === TypeActionCodes.Memo && utilisateurCourantAdminOuPiloteGroupe)
            || (action.typeActionCode === TypeActionCodes.GenerationRecent && utilisateurCourantAdmin);

        let iconActions = false;
        if (action.typeActionCode === TypeActionCodes.Memo) {
            if (action.details !== undefined && action.details.length > 0) {
                const detailMemo = action.details.find(d => d.code === ReclamationActionDetailCodes.Memo);
                if (detailMemo !== undefined) {
                    if (detailMemo.value.indexOf('sans validation de notre fournisseur') !== -1) {
                        iconActions = true;
                    }
                }
            }
        }

        let autoriseValidationDemandeGratuit = false;
        if (action.typeActionCode === TypeActionCodes.SavGesteCommercial) {
            autoriseValidationDemandeGratuit = utilisateurCourantAdmin || utilisateurCourantPiloteGroupeInterlocuteurSAV || utilisateurCourantDirecteurRegionalClient;
        }

        return (
            <Card id={"action_" + action.id} sx={{bgcolor:this.getBGColor()}}>
                <CardHeader
                    className={!emptyContent ? classes.cardHeaderWithContent : ''}
                    title={this.getTitle()}
                    subheader={action.utilisateur ? <Utilisateur utilisateur={action.utilisateur} format="simple" /> : null}
                    avatar={<Icon titleAccess={"action_" + action.id} />}

                    action=
                    {
                        removable && (
                            <IconButton onClick={e => onClickRemoveAction(action.id)} size="large">
                                <DeleteForeverIcon />
                            </IconButton>
                        )
                    }
                />

                {!emptyContent && (
                    <CardContent classes={{ root: classes.cardContent }}>

                        <Divider className={classes.divider} />

                        {action.details.map((detail, index) => {
                            return this.getDetailValue(detail, index, action.typeActionCode);
                        })}

                        {action.filesIds && action.filesIds.length > 0 && (
                            <div className={classes.filescontainer}>
                                {action.filesIds.map(x => <Fichier key={x} fichierId={x} autorise={autoriseFichier} />)}
                            </div>
                        )}

                        {iconActions && (
                            <React.Fragment>
                                <Divider className={classes.divider} />
                                <div className={classes.container}>
                                    <Typography variant="body2" className={classes.detailValue}>Merci de vous rapprocher du fournisseur pour gérer le retour et d'indiquer le résultat sur l'action "Retour fournisseur" qui se trouve dans le menu </Typography>
                                    <MoreVertIcon />
                                </div>
                            </React.Fragment>
                        )}

                        {action.actions && action.actions.length > 0 && action.actions.map((x, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <Divider className={classes.divider} />
                                    <div className={classes.container}>

                                        {this.isDevelopment && (
                                            <Tooltip title={`${x.id} - ${x.typeActionCode}`} placement={'left-start'}>
                                                <div className={classes.containerLeft}>
                                                    <Typography align="center"><Datetime withTime datetime={x.dateCreation} /></Typography>
                                                    <Typography align="center"><Utilisateur utilisateur={x.utilisateur} format="simple" /></Typography>
                                                </div>
                                            </Tooltip>
                                        )}

                                        {!this.isDevelopment && (
                                            <div className={classes.containerLeft}>
                                                <Typography align="center"><Datetime withTime datetime={x.dateCreation} /></Typography>
                                                <Typography align="center"><Utilisateur utilisateur={x.utilisateur} format="simple" /></Typography>
                                            </div>
                                        )}


                                        <div className={classes.containerRight}>
                                            {x.details.map((detail, index) => {
                                                return this.getDetailValue(detail, index, action.typeActionCode);
                                            })}

                                            {x.filesIds && x.filesIds.length > 0 && (
                                                <div className={classes.filescontainerEnfant}>
                                                    {x.filesIds.map(x => <Fichier key={x} fichierId={x} />)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            );
                        })}


                    </CardContent>
                )}


                <React.Fragment>

                    {(action.typeActionCode === TypeActionCodes.Question
                        || action.typeActionCode === TypeActionCodes.QualiteEntrepotDemandeInformations
                        || action.typeActionCode === TypeActionCodes.QualiteEntrepotDemanderControleStockMagasin) && (
                            <CardActions className={classes.cardActions}>
                                <AddReponse reclamationId={action.reclamationId} actionId={action.id} />
                            </CardActions>
                        )}

                    {(action.typeActionCode === TypeActionCodes.QualiteEntrepotDemanderRegularisationStockMagasin)
                        && action.actions.length === 0
                        && utilisateurCourantMagasinier
                        && (
                            <CardActions className={classes.cardActions}>
                                <AcknowledgeRegularisationStock reclamationId={action.reclamationId} actionId={action.id} />
                            </CardActions>
                        )}

                    {(action.typeActionCode === TypeActionCodes.SouffranceTransporteurMemo)
                        && action.actions.length === 0
                        && action.reponseAttendue
                        && (
                            <CardActions className={classes.cardActions}>
                                <AddReponseToSouffranceTransporteurMemo reclamationId={action.reclamationId} actionId={action.id} />
                            </CardActions>
                        )}


                    {(action.typeActionCode === TypeActionCodes.SavEnvoiProduitFournisseur)
                        && action.actions.length === 0
                        && (
                            <CardActions className={classes.cardActions}>
                                <ConfirmationReceptionFournisseur reclamationId={action.reclamationId} actionId={action.id} />
                            </CardActions>
                        )}


                    {(action.typeActionCode === TypeActionCodes.SavDemandePieceDetacheeFournisseur)
                        && (
                            <CardActions className={classes.cardActions}>
                                <DownloadDemandePieceDetachee actionId={action.id}/>
                            </CardActions>
                        )}


                    {(action.typeActionCode === TypeActionCodes.SavGesteCommercial)
                        && action.actions.length === 0
                        && autoriseValidationDemandeGratuit
                        && (
                            <CardActions className={classes.cardActions}>
                                <AddReponseToSavGesteCommercial reclamationId={action.reclamationId} actionId={action.id} />
                            </CardActions>
                        )}


                    {(action.typeActionCode === TypeActionCodes.ErreurGenerationAvoir)
                        && (action.actions.length === 0 || action.actions[action.actions.length - 1].reponseAttendue)
                        && (
                            <CardActions className={classes.cardActions}>
                                <RelancerGenerationAvoir
                                    reclamationId={action.reclamationId}
                                    actionId={action.id}
                                    reloadHistory={reloadHistory}
                                    utilisateurCourantAdmin={utilisateurCourantAdmin}
                                />
                            </CardActions>
                        )}


                    {/* L'action de tête est GENERATION_RECENT ; l'erreur relançable est sa dernière
                        sous-action (ERREUR_GENERATION_RECENT en attente de réponse). Le bouton cible
                        l'actionId de cette sous-action (= RelanceActionId côté service). */}
                    {(() => {
                        const derniereSousAction = action.actions && action.actions.length > 0
                            ? action.actions[action.actions.length - 1]
                            : null;

                        const erreurRelancable =
                            (action.typeActionCode === TypeActionCodes.GenerationRecent
                                && derniereSousAction
                                && derniereSousAction.typeActionCode === TypeActionCodes.ErreurGenerationRecent
                                && derniereSousAction.reponseAttendue)
                                ? derniereSousAction
                                : null;

                        return erreurRelancable && (
                            <CardActions className={classes.cardActions}>
                                <RelancerReclamationSurBonDeVente
                                    reclamationId={action.reclamationId}
                                    actionId={erreurRelancable.id}
                                    reloadHistory={reloadHistory}
                                    utilisateurCourantAdmin={utilisateurCourantAdmin}
                                />
                            </CardActions>
                        );
                    })()}


                    {(action.typeActionCode === TypeActionCodes.ComptabiliteDemandeVirement)
                        && (action.actions.length === 0 || action.actions[action.actions.length - 1].reponseAttendue)
                        && (
                            <CardActions className={classes.cardActions}>
                                <AcknowledgeDemandeVirement
                                    reclamationId={action.reclamationId}
                                    actionId={action.id}
                                    reloadHistory={reloadHistory}
                                />
                            </CardActions>
                        )}

                </React.Fragment>

            </Card>
        );
    }
}

HistoriqueCard.propTypes = {
    action: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    reloadHistory: PropTypes.func.isRequired,
};

export default withStyles(styles)(HistoriqueCard);